import { NAVIGATION_DESIGN_TYPE, NAVIGATION_POSITION_TYPE, NAVIGATION_SIZE_TYPE, NAVIGATION_THEME_TYPE, NAVIGATION_TYPE } from "./Gallery"

/* Protopia Ecosystem component */
export interface INextButtonProps {
    onClick: () => void
    navigationType: NAVIGATION_TYPE    
    navigationThemeType: NAVIGATION_THEME_TYPE
    navigationPositionType?: NAVIGATION_POSITION_TYPE
    navigationSizeType?:NAVIGATION_SIZE_TYPE
    navigationDesignType?: NAVIGATION_DESIGN_TYPE
}
const NextButton = (props: INextButtonProps): JSX.Element => {
    let className: string = `pe-next-button-${ props.navigationPositionType || "" }${props.navigationType}-${props.navigationThemeType}-${props.navigationSizeType}-container`
    return <div className={className}  onClick={props.onClick}>
        <i className={`fas fa-${props.navigationDesignType || NAVIGATION_DESIGN_TYPE.CHEVRON}-right`} />
    </div>
}
export default NextButton